const reportWebVitals = (onPerfEntry) => {
  // Web vitals reporting disabled for now
  // if (onPerfEntry && onPerfEntry instanceof Function) {
  //   import('web-vitals').then(({ onCLS, onFID, onFCP, onLCP, onTTFB }) => {
  //     onCLS(onPerfEntry);
  //     onFID(onPerfEntry);
  //     onFCP(onPerfEntry);
  //     onLCP(onPerfEntry);
  //     onTTFB(onPerfEntry);
  //   });
  // }
};

export default reportWebVitals;